/**
 * @readonly
 * @enum {string}
 */
export const FileExtension = {
  PDF: '.pdf',
  JPG: '.jpg',
  JPEG: '.jpeg',
  PNG: '.png',
  TXT: '.txt',
  CSV: '.csv',
};
